import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import { type UnitMode } from "~/domains/userPreferences/types/UnitMode";

export const downloadPC = async (type: "PDF" | "XLSX", unitMode: UnitMode) => {
  const response = await occFetch(occUrl("/product-comparison/download"), {
    body: JSON.stringify({ type, unit: unitMode }),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  await downloadBlobFromResponse(response);
};
